export const RENEWAL_CARD_CTA_AMPLITUDE = {
  SOURCE: 'Home User',
  SOURCE_DETAIL: 'Renewal Panel',
};
